export default __webpack_public_path__ + "static/2299-b72b1f7138eb919459ac61fb943462cf.gif";